var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolutions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19.9998 0 19.9998 16.9999 0 16.9999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Element_24/Solutions/Noir",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11,18 L13,18 L13,15.87 C14.73,15.43 16,13.86 16,12 C16,9.791 14.209,8 12,8 C9.791,8 8,9.791 8,12 C8,13.86 9.27,15.43 11,15.87 L11,18 Z M14,21 L14,22 C14,22.553 13.553,23 13,23 L11,23 C10.448,23 10,22.553 10,22 L10,21 L14,21 L14,21 Z M12,6 C15.313,6 18,8.687 18,12 C18,14.22 16.79,16.16 15,17.2 L15,19 C15,19.553 14.553,20 14,20 L10,20 C9.448,20 9,19.553 9,19 L9,17.2 C7.21,16.16 6,14.22 6,12 C6,8.687 8.687,6 12,6 L12,6 Z M16.95,5.63 L19.07,3.5 L20.5,4.93 L18.37,7.05 L16.95,5.63 L16.95,5.63 Z M4.92,3.5 L7.05,5.64 L5.63,7.05 L3.5,4.93 L4.92,3.5 L4.92,3.5 Z M11,4 L13,4 L13,1 L11,1 L11,4 Z M1,13 L4,13 L4,11 L1,11 L1,13 Z M20,13 L23,13 L23,11 L20,11 L20,13 Z",
    id: "Fill-1",
    fill: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutions);
export default __webpack_public_path__ + "static/media/solutions.a3c8e9cc1feb34cd4880c411e25a53bc.svg";
export { ForwardRef as ReactComponent };